/* eslint-disable */
import axios from '@/services/axios'

export default {
    listCategories(adacctSq) {
        return axios.post("/category/getCategories", adacctSq);
    },
    getOneCategory(data, source) {
        if (source)
            return axios.post("/category/getOneCategory", data, { cancelToken: source.token });
        else
            return axios.post("/category/getOneCategory", data);
    },
};
